import axios from 'axios';

axios.defaults.withCredentials = true;

export async function saveUserAction(data) {
  try {
    const response = await axios.post(`${import.meta.env.VITE_APP_API_URL}user-action`, { data });
    return response

  } catch (error) {
    console.error('Error al guardar las acciones del usuario', error);
  }
}